import React from 'react';

export const Instruction3 = () => {
  return (
    <div className="package-instruction__content">
      <p>
        <strong>UCAT EXAM RULES</strong>
      </p>
      <p>
        <strong>You have 2 minutes to read this screen.</strong>
      </p>
      <p>
        <strong>
          <u>Exam Rules</u>
        </strong>
      </p>

      <ul>
        <li>
          In attending to test you are declaring you are fit to test. If you are not fit, you must reschedule.&nbsp;
          <strong>If you choose to test against this advice, UCAT will not normally take action</strong>.
        </li>
        <li>You may only test once in any year; multiple testing will be treated as misconduct.</li>
        <li>Making noise that may disturb other test takers (including reading aloud), is prohibited.</li>
        <li>
          You must not take unauthorised items into the test room. Unauthorised items must be stored in the designated
          area; all electronic devices must be turned off before they are stored.
        </li>
        <li>You must not share or discuss test content with others.</li>
      </ul>

      <p>
        <strong>
          <u>General Test Information</u>
        </strong>
      </p>

      <ul>
        <li>
          There may be limited disturbance as test takers arrive and leave or staff assist them. You may request
          earplugs to block out noise.
        </li>
        <li>
          You will be given a laminated notebook and a pen. If you require a replacement hold the notebook or pen in the
          air to request one from the invigilator.
        </li>
        <li>
          If you need a break (e.g., to use the toilets), raise your hand to notify the invigilator. The test cannot be
          paused. You will lose time when out of the room. You may want to take breaks between subtests to limit impact
          on test time.
        </li>
      </ul>

      <p>
        Please click the&nbsp;<strong>Next (N)</strong>&nbsp;button to proceed before the time on this screen expires.
      </p>
    </div>
  );
};
